var ConditionOperator = {

     Unknown: 'Unknown'
    ,And    : 'And' 
    ,Or     : 'Or' 
}

module.exports = ConditionOperator;